var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#007540"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.89443 7.55279C5.64744 7.05881 5.04676 6.85858 4.55279 7.10557C4.05881 7.35256 3.85858 7.95324 4.10557 8.44721L5.89443 7.55279ZM6 10L5.10557 10.4472C5.23219 10.7004 5.46022 10.8881 5.73307 10.9637C6.00592 11.0393 6.29802 10.9957 6.53688 10.8437L6 10ZM12.0369 7.34366C12.5028 7.04715 12.6402 6.42907 12.3437 5.96312C12.0472 5.49718 11.4291 5.35983 10.9631 5.65634L12.0369 7.34366ZM4.10557 8.44721L5.10557 10.4472L6.89443 9.55279L5.89443 7.55279L4.10557 8.44721ZM6.53688 10.8437L12.0369 7.34366L10.9631 5.65634L5.46312 9.15634L6.53688 10.8437Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.73e4e1706eaa899da3ef2282382b76a8.svg";
export { ForwardRef as ReactComponent };